import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getPlant = createAsyncThunk(
  '/getPlant',
  async () => {
    const response = await axios.get('/GetPlant');
    return response.data;
  }
);

export const getPlantDetails = createAsyncThunk(
  '/getPlantDetails',
  async (id) => {
    const response = await axios.get(`/GetPlantDetails/${id}`);
    return response.data;
  }
);

export const setCatalogPlant = createAsyncThunk(
    '/setCatalogPlant',
    async (data) => {
      const response = await axiosHeadOffice.post(
        '/HeadOffice/SetCatalogPlant',
        data
      );
      return response.data;
    }
  );

const plantsSlice = createSlice({
  name: 'plants',
  initialState: {
    loading: false,
    error: '',
    Plants: [],
    PlantDescriptions: [],
    SelectedPlantId: 0,
    response: ''
  },
  reducers: {
    changeSelectedPlantId(state, action) {
      state.SelectedPlantId = action.payload;
    },

    resetDescriptions(state) {
      state.PlantDescriptions = [];
    }
  },

  extraReducers: {
    [getPlant.pending]: (state) => {
      state.loading = true;
    },
    [getPlant.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPlant.fulfilled]: (state, action) => {
      state.Plants = action.payload;
      state.loading = false;
    },
    [getPlantDetails.pending]: (state) => {
      state.loading = true;
    },
    [getPlantDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPlantDetails.fulfilled]: (state, action) => {
      state.PlantDescriptions = action.payload;
      state.loading = false;
    },
    [setCatalogPlant.pending]: (state) => {
      state.loading = true;
    },
    [setCatalogPlant.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setCatalogPlant.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
  }
});

export const plantsActions = plantsSlice.actions;

export default plantsSlice;
